function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#blob-1_svg__filter0_d)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  clipPath: "url(#blob-1_svg__clip0)"
}, React.createElement("path", {
  opacity: 0.2,
  d: "M113.158 72.59c20.635-14.797 48.422-12.174 73.794-11.16 25.54 1.022 51.262 3.871 73.173 17.035 22.954 13.792 45.349 32.766 52.614 58.54 7.09 25.154-10.01 49.684-14.87 75.362-4.881 25.791 3.708 56.322-13.76 75.915-17.495 19.622-48.102 17.59-73.939 22.447-24.461 4.598-49.469 13.356-72.973 5.168-23.487-8.181-38.32-29.993-53.915-49.369-15.763-19.586-36.61-38.714-37.204-63.849-.589-24.894 22.752-42.595 34.165-64.727 11.41-22.13 12.682-50.853 32.915-65.362z",
  fill: "#7C94A1"
}), React.createElement("path", {
  d: "M180.361 51.257c25.268-2.497 48.021 13.669 69.486 27.233 21.608 13.654 42.46 28.983 54.853 51.339 12.983 23.421 22.89 51.05 16.295 77.004-6.437 25.329-33.511 38.022-50.559 57.83-17.122 19.895-24.949 50.631-49.874 58.864-24.962 8.246-50.452-8.816-75.256-17.529-23.483-8.248-49.52-13.168-65.781-32.011-16.25-18.829-18.19-45.135-22.007-69.712-3.858-24.844-12.348-51.833-.295-73.898 11.937-21.853 41.002-25.512 61.951-38.973 20.947-13.459 36.409-37.698 61.187-40.147z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "blob-1_svg__clip0"
}, React.createElement("path", {
  d: "M0 0h375v375H0V0z",
  fill: "#fff"
})), React.createElement("filter", {
  id: "blob-1_svg__filter0_d",
  x: -31,
  y: -7,
  width: 437,
  height: 437.96,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 24
}), React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.729412 0 0 0 0 0.764706 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  mode: "multiply",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgBlob1(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 375 375",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgBlob1;